import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initializeSliderStory(containerId) {
    const containerSlider = $(containerId);

    const swiperHistory = new Swiper(containerId + ' .swiper', {
        modules: [Navigation, Pagination, Scrollbar],

        slidesPerView: 1,
        spaceBetween: 80,

        pagination: {
            el: containerId + ' .swiper-pagination',
            type: 'progressbar',
        },

        navigation: {
            prevEl: containerId + ' .btn-prev',
            nextEl: containerId + ' .btn-next',
        },
    });

    swiperHistory.on('slideChange', function () {
        containerSlider.find('.slider-progress .progress-fill').css('width', Math.min(this.progress * 100, 100) + '%');
    });

    swiperHistory.on('slideChangeTransitionStart', function () {
        const activeSlider = containerSlider.find('.swiper-slide-active');

        const currentSlideImg = activeSlider.data('img');

        $('.slider-history-image img').fadeOut(100, function () {
            $('.slider-history-image img').attr('src', currentSlideImg).fadeIn(100);
        });
    });
}

$(function () {
    $('.slider-history').each(function () {
        initializeSliderStory('#' + $(this).attr('id'));
    });
});
